<script setup lang="ts">
import { inject, onMounted, ref } from 'vue'

import { ServerTimeoutModal } from './services/api'
import { LoadingModal, loadingStatus } from './container/ping'
import { InformationModal } from './container/components/information'
import { downloadZipfile } from './container/ping'
import { dialog } from '@/components/modal/modal'

import type { AppType } from '=/types'

import Canvas from '@/container/Canvas.vue'
import Toast from '@/components/toast/Toast.vue'

const app = inject<AppType>('appData')!

const { component: MailModal, open: openMail, close: closeMail } = dialog(() => import('./container/components/loading/Mail.vue'))

const pendingMailDownload = ref(new URLSearchParams(window.location.search).has('filename'))

onMounted(async () => {
  const filename = new URLSearchParams(window.location.search).get('filename')
  if (!filename) {
    pendingMailDownload.value = false
    return
  }

  openMail()

  try {
    await downloadZipfile(
      {
        id: 0,
        status: 0,
        index: 0,
        message: '',
        file: filename
      },
      false
    )
    closeMail()
  } catch (error) {
    console.error('Error downloading file:', error)
    closeMail()
  } finally {
    window.history.replaceState({}, '', window.location.pathname)
    pendingMailDownload.value = false
  }
})
</script>

<template>
  <KeepAlive v-if="!pendingMailDownload">
    <Suspense>
      <Canvas :app />
    </Suspense>
  </KeepAlive>
  <Toast />
  <InformationModal :app />
  <MailModal :loading="loadingStatus" :outside="false" :app />
  <LoadingModal :loading="loadingStatus" :outside="false" :app />
  <ServerTimeoutModal size="sm" :outside="false" :app />
</template>
